import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { useAppUpgradeConfirmationQuery } from 'queries/app-upgrade-confirmation';
export const AppUpgradeConfirmation = ({ successCallback = ()=>{
    window.location.reload();
} })=>{
    const { data: showUpgradeModal = false } = useAppUpgradeConfirmationQuery();
    return /*#__PURE__*/ _jsx(Modal, {
        title: /*#__PURE__*/ _jsx(FormattedMessage, {
            id: "app_upgrade.confirmation"
        }),
        open: showUpgradeModal,
        onOk: successCallback,
        closable: false,
        cancelButtonProps: {
            hidden: true
        }
    });
};
